import { combineReducers } from 'redux';
import timeDeposit from './timeDeposit.reducer';
import simulation from './timeDeposit.simulation.reducer';
import liquidate from './timeDeposit.liquidate.reducer';
import auth from './auth.reducer';
import appModal from './appModal.reducer';
import account from './account.reducer';
import user from './user.reducer';
import challenge from './challenge.reducer';

const rootReducer = combineReducers({
  account,
  appModal,
  auth,
  simulation,
  timeDeposit,
  user,
  liquidate,
  challenge
});

export default rootReducer;
